import * as _toastr from 'toastr';

export const toastr = _toastr;
